// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SideMenuSection-sideMenuGroupCaption-EoJKi {
    margin-top: 20px;
    margin-bottom: 8px;
    font-size: 16px;
    line-height: 24px;
    font-weight: 400;
    color: var(--sideMenu-secondary-foreground);
    text-align: center;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
    gap: 4px;
    grid-gap: 4px;
}

.SideMenuSection-sideMenuGroupCaptionText-LPOPq {
    position: relative;
    display: inline-block;
    max-width: 180px;
    white-space: pre-line;
    word-break: break-word;
}

.SideMenuSection-sideMenuGroupCaptionTextIcon-baFIy {
    position: relative;
    width: 20px;
    height: 20px;
}

.SideMenuSection-sideMenuGroupCaptionTextIcon-baFIy svg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    -o-object-fit: contain;
       object-fit: contain;
}`, "",{"version":3,"sources":["webpack://./src/components/SideMenu/SideMenuSection.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,2CAA2C;IAC3C,kBAAkB;IAClB,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,QAAQ;IACR,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;IAChB,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,sBAAmB;OAAnB,mBAAmB;AACvB","sourcesContent":[".sideMenuGroupCaption {\n    margin-top: 20px;\n    margin-bottom: 8px;\n    font-size: 16px;\n    line-height: 24px;\n    font-weight: 400;\n    color: var(--sideMenu-secondary-foreground);\n    text-align: center;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 4px;\n    grid-gap: 4px;\n}\n\n.sideMenuGroupCaptionText {\n    position: relative;\n    display: inline-block;\n    max-width: 180px;\n    white-space: pre-line;\n    word-break: break-word;\n}\n\n.sideMenuGroupCaptionTextIcon {\n    position: relative;\n    width: 20px;\n    height: 20px;\n}\n\n.sideMenuGroupCaptionTextIcon svg {\n    position: absolute;\n    inset: 0;\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sideMenuGroupCaption": `SideMenuSection-sideMenuGroupCaption-EoJKi`,
	"sideMenuGroupCaptionText": `SideMenuSection-sideMenuGroupCaptionText-LPOPq`,
	"sideMenuGroupCaptionTextIcon": `SideMenuSection-sideMenuGroupCaptionTextIcon-baFIy`
};
module.exports = ___CSS_LOADER_EXPORT___;
